export default __webpack_public_path__ + "static/media/16.ab873e9a.mp3";